import { merge } from 'lodash';
import { GO_SOLAR_FUNNEL_ID } from '~/funnels/go-solar/config';
import { BillingMachine } from '~/machines/billing-selection';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { PaymentHold, PaymentHoldProps } from './payment-hold.component';

type PaymentHoldContainerProps = {
  micro: ContextSendMatch<BillingMachine>;
  overrideCopy?: PaymentHoldProps['overrideCopy'];
  overrideProps?: DeepPartial<PaymentHoldProps>;
};

export const PaymentHoldContainer = ({
  micro: { matches, send, context },
  overrideCopy,
  overrideProps,
}: PaymentHoldContainerProps) => {
  const props: PaymentHoldProps = {
    onBack: () => send({ type: 'BACK_TO_PAYMENT' }),
    onNext: () => send({ type: 'ACKNOWLEDGE_VERIFICATION' }),
    funnelId: context.funnelId,
    overrideCopy,
    status: (() => {
      if (matches('hold.success')) {
        return 'success';
      }
      if (matches('hold.error')) {
        return 'error';
      }
      if (matches('hold.timeout')) {
        return context.funnelId === GO_SOLAR_FUNNEL_ID ? 'retryOnTimeout' : 'timeout';
      }
      return 'pending';
    })(),
  };

  return <PaymentHold {...merge(props, overrideProps)} />;
};
